<div class="layout-topbar" [ngClass]="{'home': isHome && !isScrolled, 'home-scrolled': isHome && isScrolled, 'not-home': !isHome, 'mobile': isMobile }">
    <div class="topbar-left">
        <img class="logo"
             [src]="isHome && !isScrolled ? 'assets/layout/images/logo-white.png' : 'assets/layout/images/logo-white.png'"
             [routerLink]="['/']"
             alt="Tadic List"/>
    </div>
    <div class="topbar-right">
        <ul class="topbar-menu">
            <li class="menu-item" *ngIf="isHome && isScrolled && !isMobile">
                <a href="">Propiedades</a>
            </li>
            <li class="menu-item" *ngIf="isHome && isScrolled && !isMobile">
                <a href="">Conócenos</a>
            </li>
            <li class="menu-item" *ngIf="isHome && isScrolled && !isMobile">
                <a href="">Índices</a>
            </li>
            <li class="menu-item" *ngIf="isHome && isScrolled && !isMobile">
                <a href="">Planes</a>
            </li>
            <li class="icon-item" *ngIf="isHome && isScrolled && !isMobile">
                <a href="">
                    <i class="pi pi-search"></i>
                </a>
            </li>
            <li class="icon-item" *ngIf="isHome && isScrolled && !isMobile">
                <a href="">
                    <i class="pi pi-user"></i>
                </a>
            </li>
            <li class="right-sidebar-item" *ngIf="!isHome || !isScrolled || isMobile">
                <a tabindex="0" (click)="onRightMenuClick($event)">
                    <i class="pi pi-bars"></i>
                </a>
            </li>
        </ul>
    </div>
</div>
